// General
import { gsap, Power4 } from 'gsap'

import { ready } from './lib/utils/utils'

// Stimulus.js and controllers
import { Application } from 'stimulus';
import registerGeneratedControllers from './generated/register-generated-controllers';
import ExpandableController from './lib/controllers/expandable-controller';
import NavMainSubMenuController from './lib/controllers/nav-main-sub-menu-controller';
import HeaderController from './lib/controllers/header-controller';
import SearchFieldController from './lib/controllers/search-field-controller';
import AccordionController from './lib/controllers/accordion-controller';
import AccordionItemController from './lib/controllers/accordion-item-controller';
import DisruptorController from './lib/controllers/disruptor-controller';
import KeyvisualController from './lib/controllers/keyvisual-controller';
import TimelineController from './lib/controllers/timeline-controller';
import SwiperController from './lib/controllers/swiper-controller';
import DropdownController from './lib/controllers/dropdown-controller';
import ImageComparisonSliderController from './lib/controllers/image-comparison-slider.js';
import LoginPopupController from './lib/controllers/login-popup-controller.js';
import PopupController from './lib/controllers/popup-controller.js';



// Setup functions
import { SetupInViewDetection } from './lib/bootstrap/setup-in-view-detection';
import { SetupAnchorScrollTo } from './lib/bootstrap/setup-anchor-scroll-to';
import { SetupLightbox } from './lib/bootstrap/setup-lightbox';
import { SetupIsScrolledDetector } from './lib/bootstrap/setup-is-scrolled-detector';

gsap.defaults({
  ease: Power4.easeInOut,
  duration: 0.35
});

function getOffsetHeight() {
  const header = document.querySelector("header");
  const loginbar = document.querySelector(".login-bar");
  
  if (!header && !loginbar) return 0;

  const headerOffsetHeight = header ? header.offsetHeight : 0;
  const loginbarOffsetHeight = loginbar ? loginbar.offsetHeight : 0; 
  return headerOffsetHeight + loginbarOffsetHeight;
}

ready(function () {

  var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
  if (isIE11) document.body.classList.add("-is-ie-11");

  // Stimulus.js and controllers
  const application = Application.start();
  application.register('expandable', ExpandableController);
  application.register('nav-main-sub-menu', NavMainSubMenuController);
  application.register('header', HeaderController);
  application.register('search-field', SearchFieldController);
  application.register('accordion', AccordionController);
  application.register('accordion-item', AccordionItemController);
  application.register('disruptor', DisruptorController);
  application.register('keyvisual', KeyvisualController);
  application.register('timeline', TimelineController);
  application.register('swiper', SwiperController);
  application.register('dropdown', DropdownController);
  application.register('image-comparison-slider', ImageComparisonSliderController);
  application.register('login-popup', LoginPopupController);
  application.register('popup', PopupController);

  registerGeneratedControllers(application);

  // Setup functions
  SetupInViewDetection();
  SetupAnchorScrollTo(getOffsetHeight());
  SetupLightbox();
  SetupIsScrolledDetector();

});

const isThetaOmni = document.querySelector("body.site-id-3");

if (isThetaOmni) {
    window.google = {
        maps: {
            event: {
                addDomListener: function(_, __, proxyInitGmap) {
                    let intId = setInterval( function() {
                        if ("version" in google.maps) {
                            clearInterval(intId);
                            proxyInitGmap();
                        }
                    }, 1000)
                }
            }
        }
    }
}

